import SkeletonElement from "@/components/Skeleton/SkeletonElement";

function ListRowSkeleton({
  overlineWidth = "w-20",
  headlineWidth = "w-1/2",
  longContent = false
}: {
  overlineWidth?: string;
  headlineWidth?: string;
  longContent?: boolean;
}) {
  return (
    <div className="flex items-center gap-4">
      <SkeletonElement height="h-10" width="w-10" rounded="rounded-md" />
      <div className="flex-1 space-y-2">
        <SkeletonElement height="h-3" width={overlineWidth} />
        <SkeletonElement height="h-4" width={headlineWidth} />
        {longContent && <SkeletonElement height="h-4" width="w-3/4" />}
      </div>
    </div>
  );
}

export default function InteractionSideSheetSkeleton() {
  return (
    <div className="pt-7" data-testid="interaction-side-sheet-skeleton">
      <div className="flex items-start justify-between gap-4">
        <div className="flex min-w-0 flex-1 items-center space-x-4">
          <SkeletonElement height="h-12" width="w-12" rounded="rounded-full" />
          <div className="flex-1 space-y-2 py-1">
            <SkeletonElement height="h-5" width="w-3/4" />
            <SkeletonElement height="h-4" width="w-1/2" />
          </div>
        </div>
        <SkeletonElement height="h-10" width="w-32" rounded="rounded-full" />
      </div>

      <div className="mt-8 flex flex-col items-start gap-2">
        <SkeletonElement height="h-6" width="w-16" />
        <div className="w-full space-y-4">
          <ListRowSkeleton overlineWidth="w-16" headlineWidth="w-32" />
          <ListRowSkeleton overlineWidth="w-14" headlineWidth="w-48" />
          <ListRowSkeleton overlineWidth="w-20" headlineWidth="w-full" longContent />
          <ListRowSkeleton overlineWidth="w-16" headlineWidth="w-40" />
          <ListRowSkeleton overlineWidth="w-16" headlineWidth="w-40" />
          <ListRowSkeleton overlineWidth="w-20" headlineWidth="w-32" />
          <ListRowSkeleton overlineWidth="w-20" headlineWidth="w-40" />
        </div>
      </div>

      <div className="mt-8 flex flex-col items-start gap-2">
        <SkeletonElement height="h-6" width="w-20" />
        <div className="w-full space-y-4">
          <ListRowSkeleton overlineWidth="w-0" headlineWidth="w-3/5" longContent />
          <ListRowSkeleton overlineWidth="w-0" headlineWidth="w-1/2" />
        </div>
      </div>
    </div>
  );
}
